export const columnWidthInputs = {
    track: {
        min: 314,
    },
    writers: {
        min: 175,
        max: 210,
    },
    publishers: {
        min: 175,
        max: 210,
    },
    proId: {
        min: 100,
        max: 120,
    },
    plays: {
        min: 60,
        max: 90,
    },
    earnings: {
        min: 85,
        max: 100,
    },
    detections: {
        min: 100,
        max: 120,
    },
    trackActions: {
        min: 40,
        max: 40,
    },
};

export const rowHeight = 50;
export const minWidthOffset = 40;
export const defaultColumnWidth = 150;
export const titleWidthOffset = 35;
